import React from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { useI18n } from "../context/I18nContext";
import { resolveImageUrl } from "./ImageUploader";

export function About({ data = null, settings = {} }) {
  const { t } = useI18n();
  const heading = data?.heading || t.about.heading;
  const p1 = data?.p1 || t.about.p1;
  const p2 = data?.p2 || t.about.p2;
  const bullets = (data?.bullets && data.bullets.length > 0) ? data.bullets : t.about.bullets;
  const image = resolveImageUrl(data?.image) || settings.about_image;
  const whatsappPhone = settings?.whatsapp_phone ? settings.whatsapp_phone.replace(/\D/g, "") : "";
  const whatsappUrl = settings.whatsapp || (whatsappPhone ? `https://wa.me/${whatsappPhone}` : "");
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 lg:py-32 bg-[#f6f6f6]"
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div data-reveal className="lg:col-span-6">
            <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#0d1b2a]/60">
              {t.about.eyebrow}
            </div>
            <h2
              className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0d1b2a] leading-[1.05]"
              style={{ fontFamily: "Chivo, Inter, sans-serif" }}
              data-testid="about-heading"
            >
              {heading}
            </h2>
            <p className="mt-6 text-base text-[#0d1b2a]/75 leading-relaxed">{p1}</p>
            {p2 && <p className="mt-4 text-base text-[#0d1b2a]/75 leading-relaxed">{p2}</p>}

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-2 text-sm font-semibold text-[#0d1b2a]"
                  data-testid={`about-bullet-${i}`}
                >
                  <CheckCircle2 size={18} className="mt-0.5 text-[#ffb703] shrink-0" />
                  {b}
                </li>
              ))}
            </ul>

            <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn-primary mt-9" data-testid="about-cta">
              {t.nav.getQuote}
              <ArrowRight size={16} />
            </a>
          </div>

          <div data-reveal className="lg:col-span-6 relative">
            <div className="absolute -top-5 -left-5 w-32 h-32 bg-[#ffb703] rounded-2xl rotate-3 -z-0" />
            <div className="relative aspect-[5/6] rounded-2xl overflow-hidden border border-[#0d1b2a]/10 z-10">
              {image && (
                <img
                  src={image}
                  alt="About YGS"
                  className="w-full h-full object-cover"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b2a]/40 to-transparent" />

              {/* Floating stat */}
              <div className="absolute bottom-5 left-5 right-5 bg-[#0d1b2a]/95 backdrop-blur-md text-white p-5 rounded-xl border border-white/10">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.22em] text-[#ffb703] font-bold">
                      Since 2003
                    </div>
                    <div
                      className="mt-1 text-2xl font-black"
                      style={{ fontFamily: "Chivo, Inter, sans-serif" }}
                    >
                      İstanbul / TR
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-black text-[#ffb703]" style={{ fontFamily: "Chivo, Inter, sans-serif" }}>
                      120+
                    </div>
                    <div className="text-[10px] uppercase tracking-wider text-white/60 font-bold">
                      Engineers
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
